import { FC, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TextField, Button, Box, FormControlLabel, Switch } from '@mui/material';
import Swal from 'sweetalert2';

interface SyncTableStateFormProps {
    data?: any;
    onSave: (formData: any) => void;
    onClose: () => void;
}

export const SyncTableStateForm: FC<SyncTableStateFormProps> = ({ data, onSave, onClose }) => {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        id: data?.id || 0,
        tableName: data?.tableName || '',
        batchSize: data?.batchSize ?? 1000,
        isActive: data?.isActive ?? true,
    });

    useEffect(() => {
        if (data) {
            setFormData({
                id: data.id || 0,
                tableName: data.tableName || '',
                batchSize: data.batchSize ?? 1000,
                isActive: data.isActive ?? true,
            });
        }
    }, [data]);

    const handleSubmit = () => {
        if (!formData.batchSize || formData.batchSize <= 0 || formData.batchSize > 10000) {
            Swal.fire({
                icon: 'error',
                title: t('general.error'),
                text: t('studioSyncTableState.batchSizeInvalid'),
            });
            return;
        }

        onSave(formData);
    };

    return (
        <Box sx={{ padding: 3, minWidth: 400 }}>
            <h2>{t('studioSyncTableState.editTitle')}</h2>

            <TextField
                fullWidth
                label={t('studioSyncTableState.tableName')}
                value={formData.tableName}
                margin="normal"
                disabled
            />

            <TextField
                fullWidth
                label={t('studioSyncTableState.batchSize')}
                type="number"
                value={formData.batchSize}
                onChange={(e) => setFormData({ ...formData, batchSize: Number(e.target.value) })}
                margin="normal"
                required
                slotProps={{ htmlInput: { min: 1, max: 10000 } }}
            />

            <FormControlLabel
                control={
                    <Switch
                        checked={formData.isActive}
                        onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                    />
                }
                label={t('studioSyncTableState.isActive')}
            />

            <Box sx={{ display: 'flex', gap: 2, marginTop: 3, justifyContent: 'flex-end' }}>
                <Button variant="outlined" onClick={onClose}>
                    {t('general.cancel')}
                </Button>
                <Button variant="contained" onClick={handleSubmit}>
                    {t('general.save')}
                </Button>
            </Box>
        </Box>
    );
};
